import React, { Component } from 'react';
import cxs from 'cxs/component';
import { opacity } from 'helpers/Colors';
import Theme from 'Theme';
import UserRecovery from 'modules/Users/containers/UserRecovery';
import { Logo } from 'components';
class Recovery extends Component {
    render() {
        return (React.createElement(Wrapper, null,
            React.createElement(StyledLogo, { width: 250 }),
            React.createElement(UserRecovery, null)));
    }
}
export default Recovery;
const Wrapper = cxs('div')({
    boxShadow: `0 0 100px -20px ${opacity(0.25, Theme.color.primary)}`,
    margin: 'auto',
    borderWidth: `${Theme.size.hairline}`,
    borderColor: Theme.color.hairline,
    borderStyle: 'solid'
});
const StyledLogo = cxs(Logo)({
    margin: `${Theme.size.space[4]} ${Theme.size.space[4]} 0 ${Theme.size
        .space[4]}`
});



//////////////////
// WEBPACK FOOTER
// ./src/scenes/Recovery.tsx
// module id = 578
// module chunks = 0